<template>
  <router-view @showphone="showphone" v-if="showRouter"/>
  <phonedialog  ref="phonedialogref"/>
</template>
<script setup>
import { onMounted,ref } from 'vue'
import { useStore } from 'vuex'
import {useRoute,useRouter} from 'vue-router'
import {showLoadingToast,closeToast} from 'vant'
import $ from 'jquery'
import api from '@/api'
import phonedialog from '@/components/phone_dialog.vue'
const route = useRoute()
const router = useRouter()
const phonedialogref = ref(null)
const store = useStore()
const showRouter = ref(true)
const showphone = ()=>{
  phonedialogref.value.show = true
}
store.commit('initInfo')
//微信分享
var shareTitle = '我的寒假成长日记';
var shareUrl = window.location.href;
var shareDesc = " ";
var shareImg = 'https://img2.voc.com.cn/9/2026/01/29/d1f4636cce80f58d27ba17f7b317deae6f46fd041769675782137.png?pid=36720544';
$.ajax({
  url:"https://cgi.voc.com.cn/api/weixin/xhn.php?url=" + encodeURIComponent(shareUrl),
  dataType: "json",
  success: function (data) {
    $.each(data, function (index, result) {
      if (result["status"] == 1) {
        var appId = result["appId"],
          timestamp = result["timestamp"],
          nonceStr = result["nonceStr"],
          signature = result["signature"];
        wx.config({
          debug: false,
          appId: appId,
          timestamp: timestamp,
          nonceStr: nonceStr,
          signature: signature,
          jsApiList: [
            "onMenuShareTimeline",
            "onMenuShareAppMessage",
            "onMenuShareQQ",
            "onMenuShareWeibo",
            "updateAppMessageShareData",
            "updateTimelineShareData",
          ],
          openTagList: ["wx-open-launch-app"],
        });
        wx.ready(function () {
          wx.updateAppMessageShareData({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
          });
          wx.updateTimelineShareData({
              title: shareTitle,
              link: shareDesc,
              imgUrl: shareImg,
          });
          wx.onMenuShareTimeline({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
          });
          wx.onMenuShareWeibo({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
          });
        });
        wx.error(function (res) {});
      }
    });
  },
});
onMounted( async ()=>{
  // // 添加异步阻塞，等待隐式登录完成
  // await new Promise((resolve) => {
  //   setTimeout(resolve, 50);
  // });
  // console.log(route.query)
  // if(route.query.token&&route.query.user_id == 0&&store.state.userInfo.hasLogin == false){
  //   phonedialogref.value.show = true
  // }else if(route.query.token&&route.query.user_id != 0&&store.state.userInfo.hasLogin == false){
  //   store.commit('setToken',route.query.token)
  //   showLoadingToast({
  //     message: '登录中...',
  //     forbidClick: true,
  //   });
  //   api.getUserInfo({appid:store.state.userInfo.appid}).then(res=>{
  //     if(res){
  //       store.commit('setInfo',res.data)
  //       closeToast()
  //     }
  //   })
  // }
})
function isXhn(){
      var UA = window.navigator.userAgent;
      var isAndroid = UA.indexOf('Android') > 0;
      var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
      var isXinhunan = false;
       var isHarmony = UA.indexOf('OpenHarmony') > 0;
      
      if (isAndroid || isIOS||isHarmony) {
        //确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
        if(UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
        {
          isXinhunan = true;
        }	
      }
      return isXinhunan;
    }
window['onLoad'] = (e) =>{
  vmobile.getUserInfoForVote();//隐式登录
  let post_data = {
    "share_title": shareTitle,
    "share_des": " ",
    "share_img": shareImg,
    "share_url": location.href,
    "poster_img": shareImg
  }
  console.log('设置分享',post_data)
  vmobile.setShare(JSON.stringify(post_data))
}
window['setUserInfoForVote'] = (res) =>{
  console.log("用户信息",res)
      // this.setInfo(res);
    }
    window['setUserInfo'] = (res) =>{
      console.log('用户信息',res)
    }
</script>
<style lang="scss">
  @import './assets/css/common.scss';
</style>
